export default "__VITE_ASSET__abe154ff__"